import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import { connect, Provider } from "react-redux";

import App from "./App";
import createStore from "./redux/store";
import { loadDynamicOptions } from "./redux/action/dynamicOptions";

import root from "react-shadow/styled-components";

function LoadAppComponent({ loadapp, app }) {
  useEffect(() => {
    loadapp(app);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}

const mapDispatchToProp = (dispatch) => ({
  loadapp: (app) => {
    dispatch({ type: "APP_LOADED", app });
    dispatch(loadDynamicOptions(app));
  },
});
const LoadApp = connect(() => ({}), mapDispatchToProp)(LoadAppComponent);

window.initEnsPlugin = (
  id = "ens_client_root",
  app = window?.ensSettings?.page ?? "flyerRequest"
) => {
  const container = document.getElementById(id);
  console.log("Init ens frontend on " + id);
  const store = createStore();
  ReactDOM.render(
    <React.StrictMode>
      <Provider store={store}>
        <root.div>
          <App />
          <LoadApp app={app} />
        </root.div>
      </Provider>
    </React.StrictMode>,
    container
  );
};

if (!window.ensPreventAutoInit) {
  window.initEnsPlugin();
}

var event = new Event("ensloaded");
window.dispatchEvent(event);
